import axios from '../axiosApi';
import {
    FETCH_ROITREAD_CYCLES,
    RECEIVE_ROITREAD_CYCLES,
    FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,
    RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,
} from "./actionTypes";

export const fetchRoitreadCycles =  () => ({
    type: FETCH_ROITREAD_CYCLES
});

export const receiveRoitreadCycles = payload => ({
    type: RECEIVE_ROITREAD_CYCLES,
    payload: payload
});

export const dpFetchRoitreadCycleHourUsageStatistics = () => ({
    type: FETCH_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,
    payload: {
        hourUsageTotals: []
    }
});

export const dpReceiveRoitreadCycleHourUsageStatistics = payload => ({
    type: RECEIVE_ROITREAD_CYCLE_HOUR_USAGE_STATISTICS,
    payload: payload
});


export const getRoitreadCycles = () => {
    return async (dispatch, getState) => {
        dispatch(fetchRoitreadCycles());
        console.log('getting RoitreadCycles');

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;
        let payload;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }


            //TODO: insert interval parameters
            const response = await axios.get(`/roitread-ciclos`);
            payload = response.data
            console.log('getroitreadciclos response ', response.data);

        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveRoitreadCycles(payload));
        }
    }
};

export const getRoitreadCycleHourUsageStatistics = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchRoitreadCycleHourUsageStatistics());

        let hourUsageTotals;
        let hourUsageTotalsPerOperator;
        let totalUsageTimePerTypePerDay;
        let buffingStatsPerSaw;
        let buffingStatsPerSawPerOperator;
        let roitreadRithmPerOperator;
        let roitreadCycles;
        let roitreadCycleDistributionByDateAndHour;
        let ExtrusionComsuptionPerTireSize;
        let response7;

        let payload;

        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            console.log('getting raspacycle data');
            const response1 = await axios.get(`/roitread-ciclos/tempoUsoTotal?intervalo={"min":"${periodMin}","max":"${periodMax}"}`)
            hourUsageTotals = response1.data;
           // const response3 = await axios.get(`/roitread-ciclos/TotalUsageTimePerDay?Interval={"Min":"${options1.Interval.Min}","Max":"${options1.Interval.Max}"}`)
           // totalUsageTimePerTypePerDay = response3.data;
           //  const response8 = await axios.get(`/roitread-ciclos/DistributionByDateAndHour?Interval={"Min":"${options1.Interval.Min}","Max":"${options1.Interval.Max}"}`)
           // roitreadCycleDistributionByDateAndHour = response8.data;

            let url7 = `/roitread-ciclos/porMedida?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log(url7);
            response7 = await axios.get(url7)

            let url = `/roitread-ciclos/distribuicaoDataHora?intervalo={"min":"${periodMin}","max":"${periodMax}"}`;
            console.log(url);
            const response8 = await axios.get(url)
            roitreadCycleDistributionByDateAndHour = response8.data;



        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            payload = {
                hourUsageTotals: hourUsageTotals,
              //  hourUsageTotalsPerOperator: hourUsageTotalsPerOperator,
               // totalUsageTimePerTypePerDay:  totalUsageTimePerTypePerDay,
               // buffingStatsPerSaw: buffingStatsPerSaw,
               // buffingStatsPerSawPerOperator: buffingStatsPerSawPerOperator,
             //   roitreadRithmPerOperator: roitreadRithmPerOperator,
              //  roitreadCycles: roitreadCycles,
                roitreadCiclosPorMedida: response7.data,
                roitreadCycleDistributionByDateAndHour: roitreadCycleDistributionByDateAndHour,
               // ExtrusionComsuptionPerTireSize: ExtrusionComsuptionPerTireSize
            }

            dispatch(dpReceiveRoitreadCycleHourUsageStatistics(payload));
        }
    }
};








